import React from 'react';
import Box from '@mui/material/Box';
import type { FieldMapping } from '@/domain/textract/schemas';
import { TwoWayMatchColumnBindingButton } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageTwoWayMatchLayer/TwoWayMatchColumnBindings/TwoWayMatchColumnBindingButton';

type TwoWayMatchColumnBindingsProps = {
  columns: unknown;
  fields: FieldMapping[];
  width: number;
  height: number;
  onClick: (name: string) => void;
  onSelect: (index: number, mandatory: boolean | undefined) => void;
  selectedFieldIndex: number | null;
  disabledFields: number[];
  boundColumnIds: unknown;
  turnFromUpright: number;
  isLoading: boolean;
  isPending: boolean;
};

export const TwoWayMatchColumnBindings = ({
  columns,
  fields,
  width,
  height,
  onClick,
  onSelect,
  selectedFieldIndex,
  disabledFields,
  boundColumnIds,
  turnFromUpright,
  isLoading,
  isPending,
}: TwoWayMatchColumnBindingsProps) => (
  <Box
    sx={{ position: 'absolute', zIndex: 99, inset: 0, pointerEvents: 'none', '& > button': { pointerEvents: 'auto' } }}
  >
    {columns.map(({ bindingCell, name, id, metadata: { mandatory = false } }) => (
      <TwoWayMatchColumnBindingButton
        key={id}
        bound={boundColumnIds.includes(id)}
        isLoading={isLoading}
        isPending={isPending}
        isMandatory={mandatory}
        width={width}
        height={height}
        name={name}
        onClick={onClick}
        bindingCell={bindingCell}
        fields={fields}
        onSelect={onSelect}
        selectedFieldIndex={selectedFieldIndex}
        mandatoryField={mandatory}
        disabledFields={disabledFields}
        turnFromUpright={turnFromUpright}
      />
    ))}
  </Box>
);
